import { authorizedApiClient } from "./config";

export const currentUser = async () => authorizedApiClient.get("/users/me");

/**
 * Upload a user avatar via the backend (which uploads to S3 and updates PropelAuth).
 */
export const uploadCurrentUserAvatar = async (
  avatarFile: File,
  workspaceId: string,
) => {
  const formData = new FormData();
  formData.append("avatar", avatarFile);
  formData.append("workspace_id", workspaceId);

  return authorizedApiClient.put<{ picture_url: string }>("/users/me/avatar", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const user = "USER";
